import { Component, OnInit,Input } from '@angular/core';
import { Operations } from "../../../_models/Reservation/ReservationStatus";
import { Subscription } from "rxjs";
import { ReservationModel } from "../../../_models/Reservation/ReservationModel";
import { ApiService } from "../../../_services/api.service";
import { ReservationService } from "../../../_services/reservation.service";

@Component({
  selector: 'app-reservation-panel',
  templateUrl: './reservation-panel.component.html',
  styleUrls: ['./reservation-panel.component.scss']
})
export class ReservationPanelComponent implements OnInit {

  @Input() eventIdForReservation: any = "";
  public selectedTab: number = 0;

  public reservationSubscription: Subscription;
  public reservationList?: ReservationModel[] = [];
  public loadingPage: boolean = true;


  constructor(private reservationService: ReservationService,
              private apiService: ApiService) {
  }

  ngOnInit(): void {
    if(this.eventIdForReservation != ""){
      this.getReservationsByStatus();
      this.fetchReservations();
    }
  }

  fetchReservations(){
    this.reservationSubscription = this.reservationService.reservationsChanged
      .subscribe(
        (reservations: ReservationModel[]) => {
          this.reservationList = reservations;
          this.countReservations(this.reservationList);
          this.loadingPage = false;
        }
      );
    this.reservationList = this.reservationService.getReservations();
  }

  countReservations(reservationList: ReservationModel[]){
    let pendingCount:number=0,approveCount:number=0,refusedCount:number=0;
    this.reservationList?.forEach(reservation =>{
      switch(reservation.reservationStatus){
        case 'WaitingApproval': {
          pendingCount++;
          break;
        }
        case 'WaitingApprovalChanged': {
          pendingCount++;
          break;
        }
        case 'Approved': {
          approveCount++;
          break;
        }
        case 'Refused': {
          refusedCount++
          break;
        }
        case 'Canceled': {
          approveCount++;
          break;
        }
      }
    })
    // console.log("pending: "+pendingCount);
    // console.log("approved: "+approveCount);
    // console.log("refused: "+refusedCount);
  }

  getReservationsByStatus(event?: any) {
    if (!event || event.index === 0) {
      this.apiService.getReservations(this.eventIdForReservation, Operations.WaitingApproval).subscribe(_ =>
        this.apiService.getReservations(this.eventIdForReservation, Operations.WaitingApprovalChanged, true).subscribe()
      );
      return;
    }
    let status;
    if (event.index === 1) {
      status = Operations.Approved;
    } else if (event.index === 2) {
      status = Operations.Refused;
    }else if (event.index === 3) {
      status = Operations.Seated;
    }
    else {
      status = Operations.Canceled;
    }
    this.apiService.getReservations(this.eventIdForReservation, status, false).subscribe();
  }

  ngOnDestroy() {
    this.reservationSubscription.unsubscribe();
  }
}
